import apiClient from '../client'

export const stripeService = {
  createCustomerPortalSession: async ({ returnUrl } = {}) => {
    const response = await apiClient.post('/stripe/customer-portal', returnUrl ? { returnUrl } : {})
    return response.data
  },
}
